import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function EvidenceSection() {
  return <section id="evidencia" className="py-20 md:py-32 bg-dark relative overflow-hidden" data-id="element-46">
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-green-brand/5 rounded-full blur-[100px] pointer-events-none -translate-y-1/2" data-id="element-47"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-heading text-white mb-6" data-id="element-50">
            Respaldado por la Literatura Médica.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative bg-dark-surface p-8 md:p-12 rounded-3xl border border-dark-card" data-id="element-51">
          <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-green-brand/20" data-id="element-52" />

          <blockquote className="relative z-10 text-xl md:text-2xl text-gray-300 font-medium leading-relaxed text-center italic mt-4" data-id="element-53">
            "Estudios en{' '}
            <span className="text-white font-bold" data-id="element-54">
              Gynecological Endocrinology
            </span>{' '}
            confirman que la proporción 40:1 es superior a cualquier otra
            combinación en el manejo de síntomas metabólicos y ováricos."
          </blockquote>

          <div className="mt-8 flex justify-center" data-id="element-55">
            <div className="w-16 h-1 bg-green-brand/50 rounded-full" data-id="element-56"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}